export const en = {
  subscribe: {
    upgrade_subscription: 'Upgrade your Subscription',
    superpowers: 'Give Plann3r Superpowers',
    plus: 'PLUS',
    plus_price: '€3 / Month',
    one_meeting_page: '1 Meeting Page',
    link_multiple: 'Link Multiple persons to a page',
    unlimited_integrations:
      'Several Integrations with tools such as Zapier,...',
    start_trial: 'Start free trial',
    professional: 'PROFESSIONAL',
    professional_price_monthly: '€9,99 / month',
    or: 'or',
    professional_price_yearly: '€99 / year',
    multiple_pages: 'Multiple Meeting Pages',
    multiple_persons: 'Link multiple persons to a page',
    integrations: 'Unlimited integrations with CRM\'s, automation tools, ...',
    multiple_companies: 'Create multiple companies',
    support: 'Priority Support',
    trial_monthly: 'Start free trial - monthly',
    trial_yearly: 'Start free trial - yearly',
  },
  settings: {
    company: {
      invalid_email_error: 'Invalid email address',
      employees: 'Employees',
      name: 'Name',
      admin: 'Admin',
      status: 'Status',
      yes: 'yes',
      make_admin: 'Make Admin',
      pending: 'Pending',
      delete: 'delete',
      someone: 'someone',
      add_employee: 'Add Employee',
      page_name_error:
        'A page with this name already exists. Please use another name.',
      page_length_error: 'A page name must have between 1 and 25 characters.',
      page_character_error: 'A page name can only contain letters and numbers.',
      pages: 'Pages',
      edit: 'Edit',
      go_to_editor: 'Page editor',
      save_before: 'Please save the new page before you can edit.',
      share_link: 'Share link',
      add_page_placeholder: 'Page name, e.g. recruiting page',
      add_page: 'Add Page',
      edit_pages: 'Pages: edit ',
      back: 'Back',
      unconfirmed: 'unconfirmed',
      delete_page_employee: 'delete',
      page_employee_name: 'Name',
      page_employee_required: 'Required',
      not_an_employee: 'This is not one of your employees.',
      delete_confirmation:
        'Are you sure you want to completely delete the page?',
      something_went_wrong: 'Oops, something went wrong. Please try again.',
      file_size_alert: 'File must be smaller than 2MB.',
      file_extension_alert: 'Unsupported file extension.',
      dont_save: 'Don\'t save until upload is finished.',
      page_name_label: 'Name',
      page_name_placeholder: 'Sales page',
      people_label: 'People',
      people_placeholder: 'Name or email address',
      people_add: 'Add',
      colors: 'Colors',
      primary_color_label: 'Primary Color',
      primary_color_placeholder: 'Primary Color',
      secondary_color_label: 'Secondary Color',
      secondary_color_placeholder: 'Secondary Color',
      delete_page: 'Delete Page',
      company_info: 'Company Info',
      change_logo: 'Change logo: ',
      dont_save_logo: 'Don\'t save until upload is finished.',
      info_name_label: 'Name',
      info_name_placeholder: 'Company name',
    },
    settings: {
      integrations: 'Integrations',
      connect_to: 'Connect to',
      unlink: 'Unlink',
      calendars: 'Calendars',
      update_availability_error: 'Wasn\'t able to update your availability...',
      update_days_error: 'Wasn\'t able to update your available days...',
      update_information_error: 'Wasn\'t able to update your information...',
      labels: {
        information: 'My Information',
        preferences: 'My Preferences',
        pages: 'My Pages',
        integrations: 'My Integrations',
        companies: 'My Companies',
        company: 'My Company',
        data: 'My Data',
        claim_company: 'Claim Meeting Page',
      },
      upload_file_error: 'Oops, something went wrong. Please try again.',
      file_size_error: 'File must be smaller than 2MB.',
      file_type_error: 'Unsupported file extension.',
      first_name_label: 'First name',
      first_name_placeholder: 'First name',
      last_name_label: 'Last name',
      last_name_placeholder: 'Last name',
      email_label: 'Email',
      email_placeholder: 'Email',
      phone_label: 'Phone Number',
      phone_placeholder: 'Phone Number',
      videocall_label: '(Video)Call link or name',
      videocall_placeholder: 'Call information',
      timezone_label: 'Timezone',
      tier: 'Subscription',
      upgrade_subscription: 'Upgrade Subscription',
      cancel_subscription: 'Cancel Subscription',
      cancel_confirmation: 'Are you sure you want to cancel your subscription?',
      location_label: 'Default Meeting Location',
      authentication_label: 'Authentication code',
      authentication_placeholder: 'Authentication Code',
      save_button: 'Save',
      saving: 'Saving',
      change_profile_picture: 'Change profile picture: ',
      dont_save: 'Don\'t save until upload is finished.',
      primary_calendar: 'Primary calendar',
      no_primary_calendar: 'No primary calendar',
      add_calendar: 'Add a calendar',
      calendar_popup: {
        content_label: 'Add a calendar',
        title: 'Add a calendar',
        text:
          'If you have multiple work/private calendars, you can add them here.',
        button: 'Link my calendar',
      },
      preferred_time: 'Preferred Meeting Time',
      settings: 'Settings',
      new_tab: 'You will be redirected to your pages.',
      my_data: 'My Data',
      data_statement: 'At Plann3r we value your data and privacy.',
      request_data: 'Request My Data',
      request_information: 'Request Information',
      request_deletion: 'Request Account Deletion',
      privacy: 'Privacy Policy',
      cookie: 'Cookie Policy',
    },
  },
  meeting: {
    meetingdetails: {
      confirm_deletion: 'Are you sure you want to delete this meeting?',
      deletion_error:
        'Oops, we weren\'t able to delete this meeting. Please try again.',
      waiting_for: 'Waiting for',
      accepted: 'Accepted',
      declined: 'Declined',
      send_reminder: 'Send a reminder',
      permissions:
        'You don\'t have enough permissions to see this meeting-invite. Please login with the appropriate account.',
      return: 'Return to meeting overview.',
      description: 'Description: ',
      accept: 'Accept Automatically',
      accept_manually: 'Pick Moment',
      decline: 'Decline',
      invited_by: 'Invited by: ',
      delete: 'Delete meeting',
      virtual_meeting: 'Virtual Meeting',
      created_on: 'Meeting created on',
      location: 'Location:',
      required: 'Required',
      reminder_sent: 'Reminder was sent.',
      reminder_error: 'You can not send a reminder right now.',
    },
    mymeetings: {
      invited_by: 'Invited by',
      view_more: 'View more',
      to_be_determined: 'To be determined',
      declined: 'Declined',
      no_moment_found: 'No moment found',
      follow_up: 'PLAN A FOLLOW-UP',
      settings: 'Settings',
      plan_meeting: 'Plan a meeting',
      pending_meetings: 'Pending Meetings',
      no_meetings_yet: 'No meetings scheduled yet.',
      current_meetings: 'Current Meetings',
      meeting_moment: 'Meeting moment',
      history: 'History',
      meeting_date: 'Meeting date',
      meeting_created: 'Meeting created on',
    },
  },
  onboarding: {
    agendasstep: {
      title: 'Welcome to Plann3r',
      description: 'Do you have multiple calendars? Add them here!',
      sign_in_google: 'Sign in with Google',
      sign_in_exchange: 'Sign in with Exchange',
      sign_in_office: 'Sign in with Office 365',
      sign_in_icloud: 'Sign in with iCloud',
      connected: 'Connected',
      get_started_button: 'Let\'s get started',
      email: 'Email',
      password: 'Password',
      add_calendar_button: 'Add calendar',
      agendas_explanation:
        'Plann3r will use the selected agendas below to determine your availability',
      select_agendas_button: 'Select Agendas',
      next_button: 'Next',
      linked: 'You linked these calendars',
      accept: {
        text: 'I accept the ',
        link: 'terms and conditions',
      },
    },
    completed: {
      title: 'How to configure Teamleader and Plann3r?',
      step1: 'Step 1)  Activate the Teamleader integration in your Plann3r ',
      settings: 'settings',
      step2:
        'Step 2) Go to “My Pages” and claim your free company and meeting page',
      step3:
        'Step 3) Customize your meeting page! You can change colors, fields, logos, locations,...',
      step4:
        'Step 4) To select which Teamleader actions should be executed automatically, go to the meeting page editor and click the preferences tab. At the bottom of the page you can find your active integrations.',
      questions:
        'If you have any questions, you can check our Teamleader supportpage here, chat with us or send us an email at',
      have_fun: 'Have fun scheduling!',
      next: 'So what\'s next?',
      congratulations: 'Congratulations on completing the onboarding!',
      couple_of_things: 'These are a couple of cool things you can do: ',
      claim: '- Claim a free meeting-page',
      claim2: '(claim your page)',
      add_calendars: '- Add more calendars ',
      go_to_settings: '(go to settings)',
      last_step: 'Last step!',
      ready: 'You\'re ready to create your personal meeting page.',
      i_want: 'I want a free meeting page!',
      settings_2: 'I want to change my settings and add extra calendars',
    },
    locationstep: {
      title: 'Default Meeting Location',
      default_location_explanation:
        'Enter your default location here. Tip: The default location is usually your office address.',
      explanation:
        'The default location will be used for our calculations if we do not find another location in your calendar.',
    },
    rangestep: {
      title: 'Preferred meeting times',
      explanation:
        'Let Plann3r know when you want to be available for meetings. You can add multiple meeting ranges per day.',
    },
    namestep: {
      title: 'Let\'s get to know each other',
      description:
        'Enter your name here so that your guests can see the correct information.',
      first_name_label: 'Firstname',
      first_name_placeholder: 'John',
      last_name_label: 'Lastname',
      last_name_placeholder: 'Doe',
      next_button: 'Next',
    },
    gifstep: {
      title: 'Your calendar is successfully connected!',
      description: 'From now on Plann3r knows when you are not available!',
      description_2:
        'We still have 3 short questions to make sure we are completely ready to start scheduling meetings for you.',
    },
    companystep: {
      company_name_existing: 'Fill in the name of your company',
      company_name: 'Fill in your company name',
      description_existing:
        'We will send your request to the administrator of the company. You will have access once he/she accepts.',
      description:
        'We will add your first personalised meeting page to your company! You can easily add multiple pages later on.',
      tip: 'Tip: Freelancers most of the time fill in their own name',
      make_company: 'Make my company!',
      add_to_company: 'Add me to company',
      existing_company: 'I want to be added to an existing company',
      make_own_company: 'I want to make my own company',
      thanks: 'Thanks!',
      explanation:
        'We will send you an email when you are added to the company.',
    },
    notloggedin: {
      message: 'You need to be logged in to proceed in the onboarding.',
    },
    preferredtimestep: {
      title: 'Preferred Meeting Time',
      explanation:
        'Let Plann3r know when you want to be available for meetings. You can add multiple meeting ranges per day!',
      next_button: 'Next',
    },
  },
  pages: {
    pagesManagement: {
      step1: 'Add your company, we will create your first page!',
      step2:
        'Pimp your personal meeting page. Colors, extra fields, awesome logo, ...',
      step3:
        'Manage your page preferences AND activate the connection to Teamleader',
    },
    companysettings: {
      something_went_wrong: 'Oops, something went wrong. Please try again.',
      file_too_big: 'File is too big.',
      unsupported_extension: 'File extension not supported.',
      invalid_email: 'Invalid email address.',
      cannot_contain: 'That character is not supported.',
      company_logo: 'Company Logo',
      choose_file: 'Choose a file',
      best_image: 'We recommend using a square logo.',
      company_name: 'Company Name',
      change_alert:
        'Changing the company name will change the URL of every page.',
      delete: 'Delete',
      someone: 'someone',
      add_employee: 'Add Employee',
      employees: 'Employees',
      unsaved_changes: 'You have unsaved changes',
      saving_changes: 'Saving Changes',
      save_changes: 'Save Changes',
    },
    detail: {
      loading_text:
        'We are loading your pages. If this takes too long, please refresh.',
      first_page:
        'Create your first page by clicking the \'Add Company\' button on the left.',
      unsaved_changes: 'You have unsaved changes',
      saving_changes: 'Saving Changes',
      save_changes: 'Save changes',
      edit: 'Layout',
      preferences: 'Preferences',
      availabilities: 'Availabilities',
      copied: 'Copied',
      copy_clipboard: 'Copy to clipboard',
    },
    editor: {
      alert_upload:
        'Something went wrong while uploading the image. Please try again.',
      alert_file_smaller: 'Please pick a file of less than 5MB.',
      alert_unsupported_file:
        'This file extension is not supported. Supported: .jpg/.jpeg/.png/.gif',
      theme: 'Theme',
      base_color: 'Base Color',
      accent_color: 'Accent Color',
      logo: 'Logo',
      choose_file: 'Choose a file',
      generate: 'Generate Branded Logo',
      best_to_pick: 'We recommend using a square logo.',
      heading: 'Heading',
      heading_placeholder: 'E.g., Schedule a meeting with ...',
      displayName: 'Person/Company responsible for the meeting',
      schedule_a_meeting_with: 'Schedule a meeting with ',
      label: 'Label',
      example: 'Example',
      required: 'Required',
      remove: 'Remove',
      fields: 'Fields',
      add_field: 'Add Field',
      address: 'Address',
      add_another_office: 'Add another Office',
      option: 'Option',
      info: 'Info',
      add_option: 'Add Option',
      guests_can_indicate: 'Your guests can fill in the meeting address.',
      add_location: 'Add Location',
      duration: 'Meeting Type',
      delete_duration: 'Remove Meeting Type',
      add_duration: 'Add Meeting Type',
      call_to_action: 'Call to Action',
      outro: 'Confirmation Message',
      my_office: 'My Office',
      call: 'Call',
      their_office: 'Your Office',
      fetching:
        'We are loading your pages. If this takes longer than expected, please refresh the page.',
    },
    master: {
      claim_alert: 'Oops, something went wrong. Please try again.',
      settings: 'Company Settings',
      add_page: 'Add Page',
      add_company: 'Add Company',
      meeting_pages: 'Meeting Pages',
      company_name: 'Company Name',
      placeholder: 'Tesla',
      add_company_button: 'Add Company',
    },
    preferences: {
      meeting_assignment: 'Meeting Assignment',
      assignment_strategy: 'Assignment Strategy',
      assign_to: 'Assign meeting to ',
      all: 'ALL',
      persons: 'person(s)',
      one_person: '1 person',
      round_robin: 'Round Robin',
      linked_to_page: 'Linked to Page',
      must: 'Must be there',
      might: 'Might be there',
      not_an_employee:
        'We don\'t recognize this employee. Please go to your company settings to add this person to your company first.',
      one_linked:
        'At least one employee needs to be linked to this page. Please link one, before unlinking another.',
      unlink: 'Unlink',
      page_name: 'Page Name',
      cannot_contain: 'That character is not supported.',
      linked_employees: 'Linked Employees',
      people_placeholder: 'Name or email address',
      people_add: 'Add',
      temporary_page: 'Temporary Page',
      temporary_explanation:
        'A temporary page can be used for a specific event and will only show moments in a specified time frame.',
      temporary_start: 'Start',
      temporary_end: 'End',
      temporary: 'Temporary',
      autoaccept: 'Auto Accept',
      autoaccept_explanation:
        'Enabling this will automatically accept incoming meeting requests on this page.',
      one_moment: 'Only 1 moment',
      one_moment_explanation:
        'Page users can only select one meeting moment instead of multiple possible moments.',
      preferred_language: 'Preferred Language',
      preferred_language_explanation:
        'Choose the language of communication towards the page users.',
      buffer: 'Buffer',
      buffer_explanation: 'How much time should be between two meetings?',
      no_buffer: 'No buffer',
      fastest_possible: 'Fastest Possible Moment',
      fastest_possible_explanation:
        'From when should Plann3r start suggesting timeslots?',
      immediately: 'Immediately',
      sequential: 'Sequential Meetings',
      sequential_explanation:
        'Do you want to show sequential meeting blocks? (Example: for 1 hour meetings, we only suggest 9am, 10am, 11am',
      integrations: 'Integrations',
      integrations_explanation:
        'You can link your page to several CRM\'s, tools, automation services...',
      actions: 'Actions',
      on_request: 'After a meeting is requested...',
      on_schedule: 'After a meeting moment is found...',
      link_to: 'Link with this integration:',
      needs_reconnect: ' needs to be reconnected.',
      connect_to: 'Link with',
      delete_page: 'Delete Page',
    },
    availabilities: {
      preferred_times: 'Preferred Meeting Times',
      preferred_times_explanation:
        'Here you can add special availability for this meeting page. If you don\'t add anything here, we will use your personal availability and calendars',
      add_range: 'Add Range',
      ignore_calendars: 'Ignore Calendars',
      ignore_calendars_explanation_1:
        'Enabling this option will ignore your calendars when calculating available moments.',
      ignore_calendars_explanation_2:
        'We will however take into account appointments scheduled with Plann3r. (This option is mostly used for fairs and trade shows)',
      preferred_timezone: 'Preferred Timezone',
    },
    preview: {
      preview: 'Page Preview',
      fetching: 'Fetching',
      duration: 'Meeting Type',
      location: 'Location',
      meeting_schedule: 'Schedule a meeting with ',
      plan_date: 'Plan your date with ',
      required: '* Required fields',
      my_office: 'My Office',
      call: 'Call',
      your_office: 'Your Office',
      fill_in_address: 'Fill in your address',
      previewshow: {
        this_is: 'This is a',
        preview: 'preview',
        your_meeting: 'of how your meeting page would look like. Click',
        here: 'here',
        live: ' to go to your live meeting page.',
      },
    },
  },
  calendars: {
    planner_selected:
      'Plann3r will use the selected agendas below to determine your availability',
    select: 'Select Agendas',
    no_content: 'No content.',
    linked_calender: 'You linked these calendars:',
    icloud: {
      email: 'Email',
      email_placeholder: 'name@example.com',
      password: 'Password',
      add_calendar_button: 'Add calendar',
    },
    using_exchange: {
      part1:
        'Using an Exchange corporate server or another calendar solution? ',
      part2: 'Send a mail to',
      part3: 'support@plann3r.com',
      part4: 'and well get you started.',
    },
    accept: {
      text: 'I accept the ',
      link: 'terms and conditions',
    },
  },
  calendarspopup: {
    your_invitees: 'Your invitees will never see what\'s in your calendar.',
    privacy: 'PRIVACY POLICY',
  },
  header: {
    plan_meeting: 'Plan a meeting',
    features: 'How does it work?',
    pricing: 'Pricing',
    contact: 'Contact',
    blog: 'Blog',
    login: 'Sign in',
    settings: 'Settings',
    meetings: 'My Meetings',
    pages: 'My Pages',
    logout: 'Logout',
  },
  logout: {
    logging_out: 'Logging out...',
  },
  pluginpopup: {
    step1: 'Step 1: Login',
    step2: 'Step 2: Copy your authentication token',
    step3: 'Step 3: Happy scheduling',
    copy: 'Copy',
  },
  privacy: {
    title: 'Plann3r Privacy Policy',
    policy: {
      part1:
        ' Plann3r VOF, in this document also referred to as “Plann3r”, “we” or “us” values the importance of privacy. We provide this Privacy Policy to explain our services and how we collect, use and disclose information obtained from our users (“our users” refers to users of the Plann3r online platform, website plugins and all other Plann3r software,also referred to as “Plann3r Software).',
      part2:
        ' If you would have any questions regards to this Privacy Policy or how your data is treated please do contact us.',
      part3:
        'This Privacy Policy may be updated periodically. We will notify every user on the material changes by posting the new Privacy Policy on the Plann3r Website. Please consult the Plann3r Website regularly for changes.',
      part4:
        'By using our Plann3r Software you are consenting to Plann3r processing your information as described in this Privacy Policy and as would be amended by us. This may or may not include the collection, storage, disclosure, deletion and transfer of your information for the services you provided.',
    },
    title2: 'Collected Information',
    collected_info: {
      part1:
        'We collect the information provided by you, the user as well as the information provided by the use of Plann3r Software.',
      part2:
        'When scheduling a meeting with Plann3r, you voluntarily provide us with a certain set of information such as names, addresses, phone numbers (Non-exhaustive) for yourself as well as your invitees. Plann3r does not use this information for other purposes than the scheduling of meetings, improving our services and providing information on Plann3r.',
      part3:
        'You and your invitees may connect your third party calendar (iCloud, Microsoft Exchange,365, Gmail; Non-exhaustive) to Plann3r. Plann3r only connects to retrieve the calendar information necessary to find the perfect time to meet. We do not store this information, nor does Plann3r personnel know who you are meeting, for what purpose or any other confidential details about the meeting.',
      part4:
        'Permission for access to third party applications such as your Google and Microsoft mail account (non-exhaustive) are only used to obtain the information needed to schedule meetings at the appropriate time. For privacy policies or settings on these third party applications we refer you to their respective privacy and data handling policies, most commonly to be found on their product’s website.',
      part5:
        'With regards to billing information when obtaining a paid version of Plann3r, the third party payment processors will collect and store billing address and credit card data. Plann3r only stores four digits counted from the last digit backwards, as well as the expiration date provided.',
    },
    title3: 'Information Sharing',
    text1:
      'Web beacons cookies and other technologies may be used on our website to receive and store certain sets of information to ease the user’s experience as well as providing tailored marketing messages. Examples would be the function to automatically log in to Plann3r (“log data”), which may contain your web address, mobile network carrier, IP, time zone and location. This shared information can be disabled on the device you are using to access Plann3r with. Information on their respective privacy policies and data sharing can be found on their respective website. Plann3r is not responsible for any third party applications or device privacy issues.',
  },
  link: {
    almostdone: {
      meeting_schedule: 'Schedule a meeting with ',
      plan_date: 'Plan your date with ',
      pick_moment: 'Pick a moment',
      required: '* Required fields',
      please_fill:
        'Please fill in all required fields. And make sure you enter a valid email address.',
      error: 'Oops something went wrong...',
      duration: 'Meeting Type',
      location: 'Location',
      my_office: 'My Office',
      fill_in_address: 'Fill in your address',
      call: 'Call',
      your_office: 'Your Office',
      loading_calendars:
        'We are looking into the agendas to find the best possible moments. Please hold on for a second.',
    },
    bestmoments: {
      done: 'You\'re done for now!',
      send_email:
        'We\'ll send you an email when the page owner accepted, and when the meeting moment was found.',
      recommended: 'Recommended',
      free: {
        part1: 'Do you want to create your own',
        part2: 'free ',
        part3: 'Plann3r account?',
      },
      customise: ' Customise availability',
      manage: 'Manage preferences',
      send_invites: 'Send your own invites',
      activate: 'Activate my account',
      thanks: 'Thanks for requesting a meeting!',
      soon: 'I\'ll contact you as soon as possible',
      next_up: 'Ready? What happens next?',
      next_step1:
        'receives a notification and can accept or refuse your meeting request.',
      next_step2_a: 'When the meeting is accepted, you\'ll receive a',
      next_step2_b: 'confirmation email',
      next_step2_c: 'with the',
      next_step2_d: 'date and time',
      next_step2_e: 'of the meeting.',
      why_plann3r: 'Do you want your free Plann3r account?',
      plann3r_1: 'Meetings are automatically added to your calendar',
      plann3r_2: 'Create your own personalised meeting pages',
      plann3r_3: 'Meetings are only scheduled when you are really available',
      free_meeting_page: 'I want a free meeting page',
    },
    chooseamoment: {
      when_available: 'When are you available?',
      duration: 'Duration: ',
      timezone: 'Timezone: ',
    },
    linkinvitation: {
      not_valid_url: 'This is not a valid url.',
      valid_key: 'You don\'t have a valid key.',
      loading:
        'We are currently processing your request. This can take a couple of seconds...',
    },
    overview: {
      book: 'Book now',
    },
    who: {
      who_are_you: 'Who are you?',
      following_invitees: 'Which of the following invitees are you?',
      thats_me: 'That\'s me!',
    },
    meetingavailabilities: {
      select_moments: 'Select one of these possible moments',
      moments_passed:
        'The available moments have been passed. Please contact: ',
    },
    availabilities: {
      at_least_one: 'Select at least one moment.',
      calculating: 'Calculating perfect meeting moments...',
      times_shown: 'Times are shown in the ',
      timezone: ' timezone.',
      please_select:
        'Please select multiple moments. This will make sure we find the best moment for you to meet.',
      submit_button: 'Submit Moments',
      no_moments: 'No moments found...',
      weekdays: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
      months: [
        'JAN',
        'FEB',
        'MAR',
        'APR',
        'MAY',
        'JUN',
        'JUL',
        'AUG',
        'SEP',
        'OCT',
        'NOV',
        'DEC',
      ],
      step1: 'Step 2: Select a date',
      step2_a: 'Step 2: Select moments for a ',
      step2_b: 'minute meeting',
      step2_a_one_moment: 'Step 2: Select 1 slot for a ',
      best_moment: 'Best moment ',
      best_moment_for: 'Best moment for ',
      other_moments: 'Other moments',
      pick_other_moment: 'Pick other moment',
      selected_moments: 'Selected moments',
      selected_moment: 'Selected moment',
      multiple_moments: 'We advise you to select multiple moments.',
      send: 'Send',
    },
  },
  components: {
    preferredtime: {
      remove: 'Remove',
      not_available_on: 'You are not available on',
      add_range: 'Add meeting range',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    save: {
      saved: 'Saved',
      claim: 'Claim this page',
      saving: 'Saving',
      change_made: 'Changes have been made',
      save: 'Save',
    },
    emailinput: {
      i_want: 'I want to meet with ... (email)',
      valid_email: 'Please fill in a valid email.',
      fill_email: 'Please fill in an email.',
      already_invited: 'You already invited this person.',
    },
    location: {
      meeting_address: 'Meeting address',
    },
  },
}
